// extracted by mini-css-extract-plugin
export default {"RMSCodeBlock":"RMSCodeBlock_RMSCodeBlock__sxu1T","inner":"RMSCodeBlock_inner__rlalq"};